import cookie from 'js-cookie'
import i18n from '@/locales'

const isStudent = cookie.get('user_type') && JSON.parse(cookie.get('user_type')).includes('student')
const IS_PROD = process.env.NODE_ENV === 'production'

const teachingPlanProd = {
  id: '2a763f3e-a6d9-4694-8d69-23558da56d79',
  name: i18n.t('app.teachingPlan.name'),
  type: 'teachingPlan',
  desc: i18n.t('app.teachingPlan.desc'),
  img: require('@/assets/icons/ja.png'),
  content: []
}

const courseProd = {
  id: 'b6107a82-c25b-4ede-80bd-3c8da1e8d56f',
  name: i18n.t('app.course.name'),
  type: 'course',
  desc: i18n.t('app.course.desc'),
  img: require('@/assets/icons/kc.png'),
  content: []
}

const appProd = [{
  name: i18n.t('app.category.learning'),
  children: [
    {
      id: 'fb5c0af8-43c5-416b-951c-d7b2e9907536',
      name: i18n.t('app.learning.keyPoints.name'),
      desc: i18n.t('app.learning.keyPoints.desc'),
      img: require('@/assets/icons/icon_ydbs.png'),
      content: [{
        text: i18n.t('app.learning.keyPoints.text1')
      }, {
        placeholder: i18n.t('app.learning.keyPoints.placeholder1')
      }, {
        text: i18n.t('app.learning.keyPoints.text2')
      }, {
        placeholder: i18n.t('app.learning.keyPoints.placeholder2')
      }, {
        text: i18n.t('app.learning.keyPoints.text3')
      }]
    },
    {
      id: '4e9f1e7b-ce18-4700-a805-fd3360d9a3d7',
      name: i18n.t('app.learning.debate.name'),
      desc: i18n.t('app.learning.debate.desc'),
      img: require('@/assets/icons/icon_xxbl.png'),
      content: [{
        text: i18n.t('app.learning.debate.text1')
      }, {
        placeholder: i18n.t('app.learning.debate.placeholder1')
      }, {
        text: i18n.t('app.learning.debate.text2')
      }, {
        placeholder: i18n.t('app.learning.debate.placeholder2')
      }, {
        text: i18n.t('app.learning.debate.text3')
      }]
    },
    {
      id: 'b8a54564-7e26-4ba9-82f7-73264d03ff54',
      name: '阅读高手',
      desc: '提炼核心、把握思想',
      img: require('@/assets/icons/icon_ydgs.png'),
      content: [{
        text: '请输入要阅读的内容'
      }, {
        placeholder: '【输入阅读内容】'
      }, {
        text: '，提炼核心知识点和中心思想的要求是'
      }, {
        placeholder: '【请输入数字要求，如提炼要求等】'
      }]
    },
    {
      id: '12a1685a-1b95-42f9-a4eb-e8bf9beacb64',
      name: '改写专家',
      desc: '按需改进，焕新文档',
      img: require('@/assets/icons/icon_gxzj.png'),
      content: [{
        text: '请输入改写的内容'
      }, {
        placeholder: '[请输入具体内容]'
      }, {
        text: '，并说明具体的改进要求'
      }, {
        placeholder: '[请输改进要求，如字数、风格等]'
      }]
    },
    {
      id: '519b23a7-129d-43c3-bb85-66e387d6ea27',
      name: '英语练习',
      desc: '智能出题，巩固提升',
      img: require('@/assets/icons/icon_yylx.png'),
      content: [{
        text: '请输入题目类型'
      }, {
        placeholder: '【如单选题、多选题、填空题】'
      }, {
        text: '，若有具体出题知识点一并告知'
      }, {
        placeholder: '【如词汇、语法等】'
      }]
    },
    {
      id: '0233d84b-2f19-4b77-aee4-8e1ac97dbeb6',
      name: '学习规划',
      desc: '智能规划，高效学习',
      img: require('@/assets/icons/icon_xxgh.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '【期待达到的学习目标分数】'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '【输入个人学习情况，如可学习时长、弱项重点等】'
      }]
    },
    {
      id: '0b6d34d7-c227-43b4-811c-440565ee1fc9',
      name: '诗词鉴赏',
      desc: '赏诗品词，知古通今',
      img: require('@/assets/icons/icon_scjs.png'),
      content: [{
        text: '请输入诗词内容'
      }, {
        placeholder: '【输入诗词内容】'
      }, {
        text: '，根据诗词将对作者、创作背景进行介绍，如有具体的介绍要求请进行说明'
      }, {
        placeholder: '【如创作时的社会背景、作者当时的心境等】'
      }]
    }
  ]
}, {
  name: i18n.t('app.category.research'),
  children: [
    {
      id: 'f15d1348-f61e-4f75-a613-041a34c63a2f',
      name: i18n.t('app.research.techTermTranslation.name'),
      desc: i18n.t('app.research.techTermTranslation.desc'),
      img: require('@/assets/icons/sy.png'),
      content: [{
        text: i18n.t('app.research.techTermTranslation.text1')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder1')
      }, {
        text: i18n.t('app.research.techTermTranslation.text2')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder2')
      }, {
        text: i18n.t('app.research.techTermTranslation.text3')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder3')
      }, {
        text: i18n.t('app.research.techTermTranslation.text4')
      }]
    },
    {
      id: '40b83b19-7f26-42f6-9e2e-0150267b5226',
      name: i18n.t('app.research.translation.name'),
      desc: i18n.t('app.research.translation.desc'),
      img: require('@/assets/icons/icon_hy.png'),
      content: [{
        text: i18n.t('app.research.translation.text1')
      }, {
        placeholder: i18n.t('app.research.translation.placeholder1')
      }, {
        text: i18n.t('app.research.translation.text2')
      }, {
        placeholder: i18n.t('app.research.translation.placeholder2')
      }, {
        text: i18n.t('app.research.translation.text3')
      }]
    },
    {
      id: 'b8c83e96-ca79-41da-bebd-bbf1a0a9c902',
      name: '文言文研究',
      desc: '解析翻译，通晓古今',
      img: require('@/assets/icons/icon_wyw.png'),
      content: [{
        text: '请输入文言文内容'
      }, {
        placeholder: '【请输入内容】'
      }, {
        text: '，根据内容进行解析与翻译为白话文'
      }, {
        placeholder: '【如逐字逐句翻译、整体文意解读、关键句子赏析等】'
      }]
    },
    {
      id: 'c9a44a9b-d6d2-4a36-b251-fd73a0353a88',
      name: '科学问答',
      desc: '答疑解惑，科普求知',
      img: require('@/assets/icons/icon_kxwd.png'),
      content: [{
        text: '请输入关于科学、科普类的问题'
      }, {
        placeholder: '【如 冬天呼出的 “白气” 是什么？、为什么树叶到了秋天会变黄掉落？等】'
      }]
    }
  ]
}]

const teachingPlanTest = {
  id: '58e5f389-22d5-4125-8b71-77b88e170b02',
  name: i18n.t('app.teachingPlan.name'),
  type: 'teachingPlan',
  desc: i18n.t('app.teachingPlan.desc'),
  img: require('@/assets/icons/ja.png'),
  content: []
}

const courseTest = {
  id: '40e15055-d0a3-4a86-97ad-44317388db58',
  name: i18n.t('app.course.name'),
  type: 'course',
  desc: i18n.t('app.course.desc'),
  img: require('@/assets/icons/kc.png'),
  content: []
}

// const teacher = isStudent ? {} : 
const appTest = [{
  name: i18n.t('app.category.learning'),
  children: [
    {
      id: 'fb5c0af8-43c5-416b-951c-d7b2e9907536',
      name: i18n.t('app.learning.keyPoints.name'),
      desc: i18n.t('app.learning.keyPoints.desc'),
      img: require('@/assets/icons/icon_ydbs.png'),
      content: [{
        text: i18n.t('app.learning.keyPoints.text1')
      }, {
        placeholder: i18n.t('app.learning.keyPoints.placeholder1')
      }, {
        text: i18n.t('app.learning.keyPoints.text2')
      }, {
        placeholder: i18n.t('app.learning.keyPoints.placeholder2')
      }, {
        text: i18n.t('app.learning.keyPoints.text3')
      }]
    },
    {
      id: '4e9f1e7b-ce18-4700-a805-fd3360d9a3d7',
      name: i18n.t('app.learning.debate.name'),
      desc: i18n.t('app.learning.debate.desc'),
      img: require('@/assets/icons/icon_xxbl.png'),
      content: [{
        text: i18n.t('app.learning.debate.text1')
      }, {
        placeholder: i18n.t('app.learning.debate.placeholder1')
      }, {
        text: i18n.t('app.learning.debate.text2')
      }, {
        placeholder: i18n.t('app.learning.debate.placeholder2')
      }, {
        text: i18n.t('app.learning.debate.text3')
      }]
    },
    {
      id: 'b8a54564-7e26-4ba9-82f7-73264d03ff54',
      name: '阅读高手',
      desc: '提炼核心、把握思想',
      img: require('@/assets/icons/icon_ydgs.png'),
      content: [{
        text: '请输入要阅读的内容'
      }, {
        placeholder: '【输入阅读内容】'
      }, {
        text: '，提炼核心知识点和中心思想的要求是'
      }, {
        placeholder: '【请输入数字要求，如提炼要求等】'
      }]
    },
    {
      id: '12a1685a-1b95-42f9-a4eb-e8bf9beacb64',
      name: '改写专家',
      desc: '按需改进，焕新文档',
      img: require('@/assets/icons/icon_gxzj.png'),
      content: [{
        text: '请输入改写的内容'
      }, {
        placeholder: '[请输入具体内容]'
      }, {
        text: '，并说明具体的改进要求'
      }, {
        placeholder: '[请输改进要求，如字数、风格等]'
      }]
    },
    {
      id: '519b23a7-129d-43c3-bb85-66e387d6ea27',
      name: '英语练习',
      desc: '智能出题，巩固提升',
      img: require('@/assets/icons/icon_yylx.png'),
      content: [{
        text: '请输入题目类型'
      }, {
        placeholder: '【如单选题、多选题、填空题】'
      }, {
        text: '，若有具体出题知识点一并告知'
      }, {
        placeholder: '【如词汇、语法等】'
      }]
    },
    {
      id: '0233d84b-2f19-4b77-aee4-8e1ac97dbeb6',
      name: '学习规划',
      desc: '智能规划，高效学习',
      img: require('@/assets/icons/icon_xxgh.png'),
      content: [{
        text: '请输入学习目标'
      }, {
        placeholder: '【期待达到的学习目标分数】'
      }, {
        text: '，个人学习情况的说明'
      }, {
        placeholder: '【输入个人学习情况，如可学习时长、弱项重点等】'
      }]
    },
    {
      id: '0b6d34d7-c227-43b4-811c-440565ee1fc9',
      name: '诗词鉴赏',
      desc: '赏诗品词，知古通今',
      img: require('@/assets/icons/icon_scjs.png'),
      content: [{
        text: '请输入诗词内容'
      }, {
        placeholder: '【输入诗词内容】'
      }, {
        text: '，根据诗词将对作者、创作背景进行介绍，如有具体的介绍要求请进行说明'
      }, {
        placeholder: '【如创作时的社会背景、作者当时的心境等】'
      }]
    }
  ]
}, {
  name: i18n.t('app.category.research'),
  children: [
    {
      id: 'f15d1348-f61e-4f75-a613-041a34c63a2f',
      name: i18n.t('app.research.techTermTranslation.name'),
      desc: i18n.t('app.research.techTermTranslation.desc'),
      img: require('@/assets/icons/sy.png'),
      content: [{
        text: i18n.t('app.research.techTermTranslation.text1')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder1')
      }, {
        text: i18n.t('app.research.techTermTranslation.text2')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder2')
      }, {
        text: i18n.t('app.research.techTermTranslation.text3')
      }, {
        placeholder: i18n.t('app.research.techTermTranslation.placeholder3')
      }, {
        text: i18n.t('app.research.techTermTranslation.text4')
      }]
    },
    {
      id: '40b83b19-7f26-42f6-9e2e-0150267b5226',
      name: i18n.t('app.research.translation.name'),
      desc: i18n.t('app.research.translation.desc'),
      img: require('@/assets/icons/icon_hy.png'),
      content: [{
        text: i18n.t('app.research.translation.text1')
      }, {
        placeholder: i18n.t('app.research.translation.placeholder1')
      }, {
        text: i18n.t('app.research.translation.text2')
      }, {
        placeholder: i18n.t('app.research.translation.placeholder2')
      }, {
        text: i18n.t('app.research.translation.text3')
      }]
    },
    {
      id: 'b8c83e96-ca79-41da-bebd-bbf1a0a9c902',
      name: '文言文研究',
      desc: '解析翻译，通晓古今',
      img: require('@/assets/icons/icon_wyw.png'),
      content: [{
        text: '请输入文言文内容'
      }, {
        placeholder: '【请输入内容】'
      }, {
        text: '，根据内容进行解析与翻译为白话文'
      }, {
        placeholder: '【如逐字逐句翻译、整体文意解读、关键句子赏析等】'
      }]
    },
    {
      id: 'c9a44a9b-d6d2-4a36-b251-fd73a0353a88',
      name: '科学问答',
      desc: '答疑解惑，科普求知',
      img: require('@/assets/icons/icon_kxwd.png'),
      content: [{
        text: '请输入关于科学、科普类的问题'
      }, {
        placeholder: '【如 冬天呼出的 “白气” 是什么？、为什么树叶到了秋天会变黄掉落？等】'
      }]
    }
  ]
}]

if (!isStudent) {
  appTest.unshift({
    name: i18n.t('app.category.course'),
    children: [
      courseTest
    ]
  })
  appProd.unshift({
    name: i18n.t('app.category.course'),
    children: [
      courseProd
    ]
  })
}

// 知识库信息
const dataSetProd = {
  id: '8543e367-3e37-454b-af21-d7505c078835',
  name: i18n.t('app.dataSet.name')
}
const dataSetTest = {
  id: '69600add-ac2c-4aa7-b84f-a40e152d3be1',
  name: i18n.t('app.dataSet.name')
}

export const baseApp = IS_PROD ? { name: i18n.t('app.baseApp.name'), id: 'f5e4faea-739c-409b-9431-b2a5b8edcf1b' } : { name: i18n.t('app.baseApp.name'), id: '4b9113f8-1ccb-4429-bf4e-154ec7dcbade' }
export const teachingPlan = IS_PROD ? teachingPlanProd : teachingPlanTest
export const course = IS_PROD ? courseProd : courseTest
export const app = IS_PROD ? appProd : appTest
export const dataSet = IS_PROD ? dataSetProd : dataSetTest